module.exports = __webpack_public_path__ + "img/icon-5.0eadd313.svg";